import React from 'react'
import { IncentiveRadio } from '../baseComponents/IncentiveRadio/IncentiveRadio'

export const IncentivePeriod = (props: { stateName: string }) => {
    const options = [
        {
        value: "MONTHLY",
      }, {
        value: "PERIOD",
      }, {
        value: "WEEKLY",
      }
    ]
    return (
        <IncentiveRadio stateName={props.stateName} options={options}/>
    )
}
